import request from '@/utils/request'
import URL from '@/api/urlTranslator'

export function getEDITemplate(params) {
  return request({
    url: URL.sys.ediTemplate,
    method: 'get',
    params
  })
}

export function addEDITemplate(data) {
  return request({
    url: URL.sys.ediTemplate,
    method: 'post',
    data
  })
}

export function updateEDITemplate(data) {
  return request({
    url: URL.sys.ediTemplate,
    method: 'put',
    data
  })
}

export function deleteEDITemplate(uuid) {
  const params = { uuid }
  return request({
    url: URL.sys.ediTemplate,
    method: 'delete',
    params
  })
}
